/**
 * Suspense fallback — the ONLY fallback used across the app. A thin
 * top-progress bar with a data-testid so `scripts/check-prerender-fallbacks.js`
 * can detect if it ever ends up serialized into a prerendered HTML file
 * (indicates a Puppeteer race that would ship a spinner to bots).
 */
const RouteFallback = () => (
  <div
    data-testid="route-suspense-fallback"
    aria-busy="true"
    aria-live="polite"
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      height: "3px",
      background:
        "linear-gradient(90deg, transparent 0%, #c8a96a 50%, transparent 100%)",
      animation: "ac-progress 1s ease-in-out infinite",
      zIndex: 9999,
    }}
  />
);

export default RouteFallback;
